import { useContext } from 'react'
import { useQuery } from 'react-query'
import { apiGet } from 'api'
import AuthContext from 'context/auth-context'
import UserContext from 'context/user-context'

const getConflictEmployees = async (token, municipality_id, params) => {
  const url = `municipalities/${municipality_id}/conflicts/${params.conflict_id}/employees`
  const data = await apiGet({ url, token, params })
  return data
}

export function useConflictEmployees({ params, options = {} }) {
  const token = useContext(AuthContext)
  const { municipality_id } = useContext(UserContext)

  const queryFn = () => getConflictEmployees(token, municipality_id, params)
  const queryKey = ['conflictEmployees', params]
  return useQuery(queryKey, queryFn, { ...options })
}
